import type { ReactNode } from 'react';

export const symbol_eject: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M230-260h500q13 0 21.5 8.5T760-230q0 13-8.5 21.5T730-200H230q-13 0-21.5-8.5T200-230q0-13 8.5-21.5T230-260Zm10-139 215-323q5-7 11-10.5t14-3.5q8 0 14 3.5t11 10.5l215 323q10 15 1.5 31T695-352H265q-18 0-26.5-16t1.5-31Zm241-13Zm-162 0h322L480-650 319-412Z"
		/>
	</svg>
);
